const BASE_URL = import.meta.env.BASE_URL ?? ''

export const soundOptions = [
  { label: '新消息', value: `${BASE_URL}sounds/new-message.aac` },
  { label: '提示音', value: `${BASE_URL}sounds/chime.mp3` },
  { label: '蜂鸣', value: `${BASE_URL}sounds/beep.mp3` },
]

export const DEFAULT_SOUND =
  soundOptions.find(sound => sound.label === '新消息')?.value ||
  `${BASE_URL}sounds/new-message.aac`
